import { useRespostaRapidaStore } from "../../stores/respostaRapidaStore"

export const prefetchRespostasRapidasPagina = (oUsuario) => {
  if (!oUsuario?.id) return

  import(/* webpackPrefetch: true */ "../../pages/QuickMessages")

  const mFilas = oUsuario.queues?.map((oFila) => oFila.id) || []
  useRespostaRapidaStore.getState().paginadaObter({
    searchParam: "",
    pageNumber: 1,
    userId: oUsuario.id,
    filas: mFilas,
  })
}
